import styled, { css } from 'styled-components';

interface CommonTitleProps {
  $withExtra?: boolean;
}

interface MainTitleProps {
  $hideOnMobile?: boolean;
}

interface StoreProps {
  $img: string;
}

interface ContrastingProps {
  $contrasting?: boolean;
}

export const MainContainer = styled.section`
  width: 100%;
  margin: 0 auto;
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
`;

export const LogoWrapper = styled.div`
  position: relative;
  max-width: 960px;
  width: 100%;
  margin: 56px auto 86px;
  padding: 0 24px;

  @media screen and (max-width: 900px) {
    margin: 16px auto;
  }
`;

// Find location styles

export const FindLocationModuleWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  max-width: 960px;
  margin: 0 auto;

  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
`;

export const ImageLocationContainer = styled.div`
  max-width: 450px;

  > img {
    max-width: 100%;
    object-fit: contain;

    &:first-child {
      display: block;

      @media screen and (max-width: 900px) {
        display: none;
      }
    }

    &:last-child {
      display: none;

      @media screen and (max-width: 900px) {
        display: block;
      }
    }
  }

  @media screen and (max-width: 900px) {
    max-width: 375px;
    margin-bottom: 48px;
  }
`;

export const FindLocationWrapper = styled.div<CommonTitleProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  /* max-width: 330px; */
  text-align: left;

  ${({ $withExtra }) =>
    $withExtra &&
    css`
      max-width: unset;

      @media screen and (max-width: 900px) {
        max-width: 406px;
      }
    `};
  @media screen and (max-width: 900px) {
    width: 100%;
  }
`;

export const FindLocationTitle = styled.h2<CommonTitleProps>`
  font-weight: 750;
  font-size: 36px;
  line-height: 46.8px;
  color: rgba(50, 50, 50, 1);

  ${({ $withExtra }) =>
    $withExtra &&
    css`
      font-size: 48px;
      line-height: 62.4px;
    `};
  @media screen and (max-width: 900px) {
    font-size: 24px;
    line-height: 29px;
  }
`;

export const FindLocationSubtitle = styled.h3`
  font-weight: 750;
  font-size: 24px;
  line-height: 31px;
  color: rgba(50, 50, 50, 1);
  margin-top: 10px;

  @media screen and (max-width: 900px) {
    font-size: 16px;
    line-height: 20.8px;
    margin-top: 48px;
    order: 2;
  }
`;

export const FindLocationHint = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18.2px;
  color: rgba(50, 50, 50, 1);
  margin-top: 8px;

  @media screen and (max-width: 900px) {
    font-size: 14px;
    line-height: 18.2px;
    margin-top: 12px;
    order: 2;
  }
`;

export const EnterNumberText = styled.p<CommonTitleProps>`
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(50, 50, 50, 1);
  margin-top: 16px;

  ${({ $withExtra }) =>
    $withExtra &&
    css`
      font-weight: 750;
      margin-top: 24px;
    `};
  @media screen and (max-width: 900px) {
    margin: 12px 0 24px;
    font-weight: 400;
  }
`;

export const ImagesWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 10px;

  img {
    width: 97px;
    height: 31px;
  }

  @media screen and (max-width: 900px) {
    width: 100%;
    justify-content: center;
  }
`;
// Steps styles

export const StepsListWrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 80px auto;
  max-width: 960px;
  text-align: left;
  padding: 0 24px;

  @media screen and (max-width: 900px) {
    margin: 0 auto 48px;
    max-width: 458px;
  }
`;

export const MainTitle = styled.h2<MainTitleProps>`
  font-weight: 750;
  font-size: 36px;
  line-height: 46.8px;
  color: rgba(50, 50, 50, 1);
  white-space: pre-line;

  > span {
    color: #1f7ace;

    @media screen and (max-width: 900px) {
      color: rgba(50, 50, 50, 1);
    }
  }

  @media screen and (max-width: 900px) {
    font-size: 24px;
    line-height: 29px;
    white-space: normal;
    ${({ $hideOnMobile }) =>
      $hideOnMobile &&
      css`
        display: none;
      `}
  }
`;

export const StepsList = styled.ul`
  list-style: none;
  display: flex;
  width: 100%;
  gap: 30px;
  margin-top: 32px;

  @media screen and (max-width: 900px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const StepsListItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 16px;

  &:nth-child(1) {
    flex-basis: 270px;
  }

  &:nth-child(2) {
    flex-basis: 300px;
  }

  &:nth-child(3) {
    flex-basis: 340px;
  }

  @media screen and (max-width: 900px) {
    align-items: center;

    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3) {
      flex-basis: unset;
    }
  }
`;

export const StepsListItemNumber = styled.div`
  background-color: rgba(223, 240, 255, 1);
  border-radius: 15px;
  border: 1px solid rgba(51, 147, 236, 1);
  min-width: 64px;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: 750;
    font-size: 44px;
    line-height: 40px;
    color: rgba(51, 147, 236, 1);
    height: 34px;

    @media screen and (max-width: 900px) {
      font-size: 32px;
      line-height: 29px;
      height: 25px;
    }
  }

  @media screen and (max-width: 900px) {
    min-width: 47px;
    min-height: 47px;
  }
`;

export const StepsContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  h3 {
    font-weight: 750;
    font-size: 18px;
    line-height: 23.4px;
    color: rgba(50, 50, 50, 1);

    @media screen and (max-width: 900px) {
      font-size: 16px;
      line-height: 20.8px;
    }
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 18.2px;
    color: rgba(50, 50, 50, 1);

    @media screen and (max-width: 900px) {
      font-size: 12px;
      line-height: 15.6px;
    }
  }
`;

// Press styles

export const PressWrapper = styled.section`
  background-image: url(${'/images/press/press-bg.png'});
  background-size: 100% 100%;
  min-height: 700px;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 80px;

  @media screen and (max-width: 900px) {
    background-image: none;
    min-height: unset;
    justify-content: flex-start;
    padding: 0 24px;
    margin-bottom: 0;

    h2 {
      order: 3;
      text-align: left;
      width: 100%;
      max-width: 400px;
    }
  }
`;

export const PressLogos = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
  background-image: url(${'/images/press/the-new-york-times.png'});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 24px;

  @media screen and (max-width: 900px) {
    order: 3;
    height: 90px;
    max-width: 400px;
    margin-bottom: 0;
  }

  &::before,
  &::after {
    content: '';
    display: block;
    background-size: inherit;
    background-position: inherit;
    background-repeat: inherit;
  }

  &::before {
    width: 128px;
    height: 128px;
    background-image: url(${'/images/press/c-net.png'});

    @media screen and (max-width: 900px) {
      width: 76px;
      height: 76px;
    }
  }

  &::after {
    width: 161px;
    height: 111px;
    background-image: url(${'/images/press/the-verge.png'});

    @media screen and (max-width: 900px) {
      width: 96px;
      height: 66px;
    }
  }
`;

export const QuoteWrapper = styled.div`
  width: 327px;
  padding: 20px 32px;
  border-radius: 29px;
  text-align: center;
  position: absolute;
  bottom: -80px;
  background: #fff;
  box-shadow: 0 0 23px rgba(37, 70, 66, 0.22);

  @media screen and (max-width: 900px) {
    box-shadow: none;
    background-color: rgba(223, 240, 255, 1);
    position: relative;
    bottom: 0;
    margin-bottom: 16px;
    padding: 19px 16px 16px;
    width: unset;
  }
`;

export const QuoteTitle = styled.div`
  color: rgba(51, 147, 236, 1);
  font-size: 24px;
  font-weight: 750;
  line-height: 24px;
`;

export const QuoteDescription = styled.div`
  color: rgba(50, 50, 50, 1);
  font-size: 14px;
  font-weight: 400;
  line-height: 16.7px;
  margin-top: 8px;
`;

export const QuoteBlock = styled.div`
  width: 265px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px auto 0;
  color: rgba(50, 50, 50, 1);
  font-size: 14px;
  font-weight: 750;
  line-height: 21px;

  &::before,
  &::after {
    content: '';
    display: block;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  &::before {
    margin-bottom: 16px;
    width: 21px;
    height: 21px;
    background-image: url(${'/images/press/quote-icon.svg'});
  }

  @media screen and (max-width: 900px) {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.12);
    padding: 16px;
  }
`;

export const QuoteIcon = styled.div`
  width: 43px;
  height: 29px;
  background-image: url(${'/images/press/the-verge.png'});
  background-size: contain;
  margin: 12px auto 0;

  @media screen and (max-width: 900px) {
    width: 43px;
    height: 29px;
  }
`;

// Reviews styles

export const ReviewsWrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 56px auto 96px;
  padding: 0 24px;
  max-width: 960px;
  width: 100%;

  @media screen and (max-width: 900px) {
    margin: 48px auto 24px;
    padding: 0 12px;
  }
`;

export const ReviewsList = styled.div`
  display: flex;
  gap: 26px;

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const ReviewItem = styled.div`
  background: rgba(244, 244, 244, 1);
  border-radius: 13px;
  border: 1px solid rgba(214, 214, 214, 1);
  padding: 16px;
  flex: 1;

  @media screen and (max-width: 900px) {
    border: none;
    box-shadow: 0 0 14px rgba(0, 0, 0, 0.15);
  }
`;

export const ReviewHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
`;

export const ReviewBody = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const ReviewerPhoto = styled.img`
  width: 30px;
  height: 30px;
  margin-right: 8px;
`;

export const ReviewerName = styled.span`
  font-weight: 750;
  font-size: 14px;
  line-height: 21px;
  color: rgba(50, 50, 50, 1);
`;

export const UserIcon = styled.div`
  width: 12px;
  height: 15px;
  background-image: url(${'/images/reviews/app-icon.png'});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

export const Label = styled.div`
  background: rgba(233, 233, 233, 1);
  font-weight: 750;
  font-size: 6px;
  line-height: 7px;
  color: rgba(91, 91, 91, 1);
  border-radius: 2px;
  padding: 2px;
  margin: 0 7px;
  letter-spacing: -0.24px;
  text-transform: capitalize;
`;

export const Rate = styled.div`
  width: 57px;
  height: 10px;
  background-image: url(${'/images/reviews/stars.png'});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

export const ReviewText = styled.div`
  font-weight: 400;
  font-size: 15px;
  line-height: 18.2px;
  color: rgba(50, 50, 50, 1);
  letter-spacing: -0.24px;
  text-align: left;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 12px;
`;

// Features styles

export const FeaturesWrapper = styled.section`
  margin: 0 auto 53px;
  max-width: 960px;
  width: 100%;
  text-align: left;
  padding: 0 24px;

  @media screen and (max-width: 900px) {
    margin: 0 auto 48px;
    padding: 0 30px;
  }

  @media screen and (max-width: 380px) {
    padding: 0 16px;
  }
`;

export const StoreButtons = styled.div`
  display: none;

  @media screen and (max-width: 900px) {
    width: 100%;
    max-width: 330px;
    min-width: 330px;
    display: flex;
    justify-content: space-between;
    text-align: center;
    background-color: #fff;
    padding: 24px 11px;
    position: relative;
    margin: 0 auto;
  }

  &::after {
    content: '';
    display: block;
    width: 1px;
    height: 75px;
    background-color: #e3e3e3;
    position: absolute;
    top: calc(50% - 37px);
    left: calc(50% - 1px);
  }
`;

export const Store = styled.div<StoreProps>`
  padding: 34px 10px 10px;
  background-image: url(${({ $img }) => $img});
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 65%;
`;

export const StoreRating = styled.div`
  font-size: 16px;
  line-height: 19px;
  color: #323232;
`;

export const Stars = styled.div`
  width: 120px;
  height: 20px;
  background: url(${'/images/welcome/store-stars.png'}) center / contain no-repeat;
  margin: 4px auto 12px;
`;

export const StoreRatingsCount = styled.div`
  font-size: 16px;
  line-height: 19px;
  color: #323232;
  margin-top: 12px;
`;

export const FeatureButtonWrapper = styled.div`
  display: none;

  @media screen and (max-width: 900px) {
    display: flex;
    justify-content: center;
    margin: 0 -6px;
  }

  @media screen and (max-width: 380px) {
    margin: 0 8px;
  }
`;

// How it works styles

export const HowWorksWrapper = styled.section`
  padding: 0 24px;

  @media screen and (max-width: 900px) {
    padding: 0;
    max-width: 458px;
    margin: 0 auto;
  }
`;

export const HowWorks = styled.div`
  max-width: 960px;
  width: 100%;
  background: linear-gradient(98deg, #fff 0%, #daebfa 48.82%);
  border-radius: 64px;
  border: 1px solid rgba(51, 147, 236, 1);
  padding: 60px 80px;
  display: flex;
  margin: 0 auto;

  @media screen and (max-width: 900px) {
    padding: 0 24px;
    border: none;
    background: none;
    flex-direction: column;
    align-items: center;
  }
`;

export const Divider = styled.div`
  min-width: 1px;
  background-color: rgba(51, 147, 236, 1);
  margin: 0 7%;

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const HowWorksList = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 27px;

  @media screen and (max-width: 900px) {
    margin-top: 48px;
  }

  li {
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3) {
      flex-basis: unset;
    }
  }
`;

export const HowWorkTitle = styled.h2`
  font-weight: 750;
  font-size: 24px;
  line-height: 29px;
  color: rgba(50, 50, 50, 1);
`;

// Footer styles

export const FooterWrapper = styled.footer<ContrastingProps>`
  ${({ $contrasting }) =>
    $contrasting
      ? `
		background-color: rgb(251,251,251);
		max-width: 343px;
		width: 100%;
		margin: 0 auto;
		padding: 24px 51px;

		@media screen and (max-width: 450px) {
			max-width: 100vw;
		}
	`
      : `
		max-width: 240px;
		width: 100%;
		margin: 96px auto 56px;
	
		@media screen and (max-width: 900px) {
			margin: 48px auto 24px;
		}
	`};
`;

export const CopyrightText = styled.p<ContrastingProps>`
  font-weight: 400;
  font-size: 12px;
  line-height: 15.6px;
  color: ${({ $contrasting }) => ($contrasting ? 'rgb(132,132,132)' : 'rgb(166,166,166)')};
  margin-top: 16px;
  white-space: pre-line;
`;

export const Links = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LinksItem = styled.div<ContrastingProps>`
  text-decoration: underline;
  text-align: right;
  width: 49%;
  font-weight: 400;
  font-size: 12px;
  line-height: 15.6px;
  color: ${({ $contrasting }) => ($contrasting ? 'rgb(132,132,132)' : 'rgb(50,50,50)')};
  cursor: pointer;

  &:last-child {
    margin-left: 70px;
    text-align: left;
  }
`;
